import React from 'react';

import {
  useDeleteIo,
  useApproveIo,
  useMoreInfoIo,
  useRejectIo,
  useTerminateIo,
  useUndoIo,
  useMarkAsSignedIo,
  useMarkAsAgreementWithNoChangesIo,
  useResendIoToPartner,
  useCommentIO,
} from '../../data';
import { Actions } from './Actions';
import { TAB_ACTIONS_LOG } from '../../constants';
import { useScreenGo } from '@gogame/screens';

export const IoActions = ({
  actions,
  data,
  onAddAmendment,
  onEdit,
  onDelete,
  withViewLog = true,
}) => {
  const [deleteIo] = useDeleteIo(data);
  const [approveIo] = useApproveIo(data);
  const [moreInfo] = useMoreInfoIo(data);
  const [rejectIo] = useRejectIo(data);
  const [terminateIo] = useTerminateIo(data);
  const [undoIo] = useUndoIo(data);
  const [markAsSignedIo] = useMarkAsSignedIo(data);
  const [markAsAgreementIo] = useMarkAsAgreementWithNoChangesIo(data);
  const [resendIoToPartner] = useResendIoToPartner();
  const [commentIO] = useCommentIO(data);
  const go = useScreenGo();

  const handleDelete = async () => {
    await deleteIo();
    onDelete?.(data);
  };

  const handleApprove = () => {
    approveIo();
  };

  const handleMoreInfo = () => {
    moreInfo();
  };

  const handleReject = () => {
    rejectIo();
  };
  const handleTerminate = () => {
    terminateIo();
  };

  const handleUndo = () => {
    undoIo();
  };

  const handleMarkAsSigned = () => {
    markAsSignedIo();
  };

  const handleMarkAsAgreementIo = () => {
    markAsAgreementIo();
  };

  const handleAddComment = () => {
    commentIO();
  };

  const handleViewLog = () => {
    go(data.id, {
      state: { activeTabId: TAB_ACTIONS_LOG },
    });
  };

  const handleAddAmendment = () => onAddAmendment?.(data);
  const handleEdit = () => onEdit?.(data);
  const handleResend = () => resendIoToPartner(data);

  return (
    <Actions
      actions={actions}
      hasComments={data?.hasComments}
      withViewLog={withViewLog}
      onDelete={handleDelete}
      onApprove={handleApprove}
      onMoreInfo={handleMoreInfo}
      onReject={handleReject}
      onTerminate={handleTerminate}
      onUndo={handleUndo}
      onSignByPartner={handleMarkAsSigned}
      onMarkAsAgreement={handleMarkAsAgreementIo}
      onAddComment={handleAddComment}
      onAddAmendment={handleAddAmendment}
      onEdit={handleEdit}
      onViewLog={handleViewLog}
      onResend={handleResend}
    />
  );
};

export default IoActions;
